import React, { useState } from 'react'
import { Outlet } from 'react-router-dom';
import Navbar from '../Navbar/index';
import Sidebar from '../Sidebar/Sidebar';
import './mainlayout.css'

const Layout = () => {
    const [isCollapse, setIsCollapse] = useState(false);
    const sidebarWidth = 260; // Width when sidebar is expanded

    const handleToggleSidebar = () => {
        setIsCollapse(!isCollapse);
    };

    return (
        <div className='mainContainer'>
            <Sidebar 
                isCollapse={isCollapse} 
                handleToggleSidebar={handleToggleSidebar}
                width={sidebarWidth}
            />
            <div 
                className='main' 
                style={{ 
                    // marginLeft: isCollapse ? `${sidebarWidth}px` : '0',
                    width: isCollapse ? `calc(100% - ${sidebarWidth}px)` : '100%'
                }}
            >
                <Navbar />
                <div className='outlet'>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Layout;